/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectTextIcon32Regular = forwardRef('CommentRectTextIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M8 16a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M9 11a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H9Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 8.5A5.5 5.5 0 0 1 7.5 3h17A5.5 5.5 0 0 1 30 8.5v11a5.5 5.5 0 0 1-5.5 5.5h-7.78l-6.557 4.684C8.838 30.63 7 29.684 7 28.057v-3.08A5.5 5.5 0 0 1 2 19.5v-11ZM7.5 5A3.5 3.5 0 0 0 4 8.5v11A3.5 3.5 0 0 0 7.5 23H8a1 1 0 0 1 1 1v4.057l6.819-4.87A1 1 0 0 1 16.4 23h8.1a3.5 3.5 0 0 0 3.5-3.5v-11A3.5 3.5 0 0 0 24.5 5h-17Z" })));
});
